import React from "react";
import { AiFillStar } from "react-icons/ai";
import { useTranslation } from "../i18n";
import jlptN5Certificate from "../Assets/JAPANESE_N5.jpeg";

function JlptBadge() {
  const { t, language } = useTranslation();

  if (language !== "ja") {
    return null;
  }

  return (
    <a
      href={jlptN5Certificate}
      target="_blank"
      rel="noreferrer"
      className="jlpt-badge jlpt-badge-link"
      aria-label={`${t("navbar.jlptBadge")} — ${t("navbar.jlptBadgeSub")}`}
    >
      <AiFillStar className="jlpt-badge-star" aria-hidden="true" />
      <div className="jlpt-badge-text">
        <span className="jlpt-badge-label">{t("navbar.jlptBadge")}</span>
        <span className="jlpt-badge-sub">{t("navbar.jlptBadgeSub")}</span>
      </div>
    </a>
  );
}

export default JlptBadge;
